<template>
    <div>
        <h1 class="first-header heading-large"><i class="fas fa-handshake mr-2"></i>Today's Negotiations</h1>
        <div class="card conversations--wrapper overflow-auto bg-olf-light-greyish-blue">
            <h3 class="heading-medium pl-4 pb-3 mb-0 border-bottom">Products</h3>
            <div v-if="negotiationFuelGroups.length < 1" class="text-center m-4">
                Loading negotiations...
            </div>
            <div v-else>
                <a 
                    href="#" 
                    class="conversations--action d-flex justify-content-between border-bottom text-decoration-none" 
                    data-toggle="modal" data-target="#myNegotiation"
                    :class="{active: fuelGroupSelected && fuelGroup.fuel._id == fuelGroupSelected.fuel._id}"
                    v-for="(fuelGroup, key) in negotiationFuelGroups" :key="key" @click="showFuelGroupNegotiations(fuelGroup.fuel._id)"
                >   
                    <div class="d-flex justify-content-start">
                        <span class="conversations--image m-3 position-relative font-weight-bold" :class="{'all-offline': !isAnySellerOnline[key]}">
                            {{fuelGroup.negotiationList.length}}
                            <i class="fas notification" v-if="notificationList.find(n => n.type_id === 'NEGOTIATION' && fuelGroup.negotiationList.find(nego => n.group_id === nego._id) && n.viewed == null)"></i>
                        </span>
                        <div class="conversations--info text-tertiary align-items-center d-flex">
                            <h5>{{fuelGroup.fuel._id | fueltype}}</h5>
                        </div>
                    </div>
                    <span class="d-flex align-items-center mr-3"><i class="fas fa-caret-right text-tertiary"></i></span>
                </a>     
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations,mapGetters } from 'vuex';

export default {
    data:function(){
        return{
            populateCompleted:false,
            isAnySellerOnline: []
        }
    },
    created(){
        const payload = {
            status: 'All',
            accountId: this.userLoggedIn.id
        }
        this.getNegotiations(payload)
    },
    computed: {
        ...mapState('negotiation',['negotiationFuelGroups', 'fuelGroupSelected']),
        ...mapState('login',['userLoggedIn']),
        ...mapState('notifications', ['notificationList']),
        ...mapGetters('negotiation',['getNegotiationListChanges'])
    },
    methods: {
        ...mapMutations('negotiation', ['SELECT_TAB']),
        ...mapActions('negotiation', ['selectFuelGroup', 'getNegotiations', 'setNegotiationSelectedId']),
        showFuelGroupNegotiations: function(fuelId){
            this.SELECT_TAB(0)
            this.setNegotiationSelectedId('')
            this.selectFuelGroup(fuelId)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_conversations.scss";
</style>    